export default "__VITE_ASSET__B98onpoS__"